import Entities from 'STORE';
import { IPushNotification } from 'STORE/PushNotifications/PushNotifications.types';

import { onNewSessionClick } from '../utils/onNewSessionClick';
import { onNotificationClose } from '../utils/onNotificationClose';
import { prepareNotificationOptions } from '../utils/prepareNotificationOptions';

export const handleDeviceAdded = (pushNotification: IPushNotification): void => {
  if (!pushNotification.group) {
    return;
  }

  const options = prepareNotificationOptions(pushNotification);

  const notification = new Notification(pushNotification.title || '', options);
  Entities.pushNotifications.addNotification(notification);
  notification.onclick = (): Promise<void> => onNewSessionClick(pushNotification, notification);
  notification.onclose = (): void => onNotificationClose(notification);
  notification.onerror = (): void => onNotificationClose(notification);
};
